module.exports = __webpack_public_path__ + "img/search-icon.11b21f9d.svg";